import { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../../../../components/Common/UI/Accordion';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import Separator from '../../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { cn } from '../../../../../../../utils/styles';
import { accordionData } from '../Data';
import { PdfViewerTrigger } from '../../../../../../../context/pdfViewerDialog';
import ModalSendStatement from '../Modals/Send';

const pathToHTML = '../../UnreviewedDocumentPage/December-Statement_eStatements.html';
const pathToActive = '../../eStatements.zip';
const pathToPDF = '/infoTrac/jobDetails/statementMessage.pdf';

function AccountDetailStatements() {
  const [activeIndex, setActiveIndex] = useState<string>('0');
  const [activeItemIndex, setActiveItemIndex] = useState<string>('');

  const handleActiveIndex = (index: string) => {
    setActiveIndex(activeIndex === index ? '' : index);
    setActiveItemIndex('');
  };

  const handleItemClick = (index: string) => {
    setActiveItemIndex(activeItemIndex === index ? '' : index);
  };

  const handleDownload = (isPDF: boolean) => {
    const link = document.createElement('a');

    link.href = isPDF ? pathToPDF : pathToActive;
    link.download = isPDF ? 'statement.pdf' : 'statement.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Accordion type="single" collapsible defaultValue="0">
      {accordionData.map(el => (
        <AccordionItem key={el.id} value={el.id} className="p-0 border rounded-lg overflow-hidden mb-[10px]">
          <AccordionTrigger className="p-0 block bg-primary" onClick={() => handleActiveIndex(el.id)}>
            <div
              className="flex items-center gap-[20px] bg-[#5582B42E] !px-[20px] min-h-[44px]
                justify-between"
            >
              <div className="font-mediul text-white text-[13px]">{el.title}</div>
              <Icons.PlusMinusAnimated className="[&_rect]:fill-white" active={el.id !== activeIndex} />
            </div>
          </AccordionTrigger>
          <AccordionContent
            className="p-[30px] pb-[40px] flex flex-wrap
              gap-[20px] xl:gap-[30px] items-start"
          >
            {el.content.map(el2 => (
              <div key={el2.id} className="rounded-lg bg-[#5582B42E] min-w-[195px]">
                <Button
                  variant="ghost"
                  className="p-0 block text-center w-full h-auto relative group"
                  onClick={() => handleItemClick(el2.id)}
                >
                  {/* <div className="uppercase text-left absolute px-[10px] py-[15px] right-[-30px] top-[-30px]
                      hidden tracking-tighter group-hover:block w-[150px] bg-white text-primary text-[12px]
                      font-bold leading-[12px] shadow before:content before:w-[15px] before:h-[20px] before:rotate-45
                      before:absolute before:right-[65px] before:bg-white before:bottom-[-7px] rounded"
                      >
                        <div>Monthly statement</div>
                        <div>and escrow analysis</div>
                      </div> */}
                  <div className="text-primary text-[16px] font-bold text-center pt-[5px] pb-[3px]">{el2.date}</div>
                  <div
                    className="uppercase text-primary text-center font-medium text-[12px] mb-[5px]"
                    title="Monthly statement and escrow analysis"
                  >
                    Monthly Statement...
                  </div>
                </Button>
                <div className={cn('pb-[20px] hidden', { block: el2.id === activeItemIndex })}>
                  <Separator className="mt-[5px] mb-[15px]" />
                  <div className="grid gap-[20px] px-[20px]">
                    <PdfViewerTrigger src={pathToPDF}>
                      <Button variant="ghost" className="flex gap-[10px] p-0 justify-start h-auto">
                        <Icons.EyeFilled className="[&_path]:fill-primary" />
                        <div className="text-primary text-[16px]">View PDF</div>
                      </Button>
                    </PdfViewerTrigger>
                    <Button
                      variant="ghost"
                      className="flex gap-[10px] p-0 justify-start h-auto"
                      onClick={() => handleDownload(true)}
                    >
                      <Icons.DownloadFilled className="[&_path]:fill-primary" />
                      <div className="text-primary text-[16px]">Download PDF</div>
                    </Button>
                    {/* <Button */}
                    {/*  variant="ghost" */}
                    {/*  className="flex gap-[10px] p-0 justify-start h-auto" */}
                    {/*  onClick={handleOpenHTML} */}
                    {/* > */}
                    {/*  <Icons.Web className="[&_path]:fill-primary" /> */}
                    {/*  <div className="text-primary text-[16px]">View HTML</div> */}
                    {/* </Button> */}
                    {/* <Button */}
                    {/*  variant="ghost" */}
                    {/*  className="flex gap-[10px] p-0 justify-start h-auto" */}
                    {/*  onClick={() => handleDownload(false)} */}
                    {/* > */}
                    {/*  <Icons.DownloadNew2 className="[&_path]:fill-primary" /> */}
                    {/*  <div className="text-primary text-[16px]">Download HTML</div> */}
                    {/* </Button> */}
                    <ModalSendStatement />
                    {/*
                          <div className="text-primary uppercase text-center font-medium text-[13px]">Inserts</div>
                        */}
                    {/* <div className="underline text-[#2368B4] font-medium text-[13px] leading-[14px]"> */}
                    {/*
                          <Link to="/infoTrac" className="mb-[5px] cursor-pointer block">Terms and Conditions...</Link>
                        */}
                    {/*  <Link to="/infoTrac" className="cursor-pointer block">Offers for checking me...</Link> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            ))}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default AccountDetailStatements;
